import { render } from "./HeroListShowDetailNotice.vue?vue&type=template&id=462e45c2"
import script from "./HeroListShowDetailNotice.vue?vue&type=script&lang=js"
export * from "./HeroListShowDetailNotice.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gaomingliang/github/vue3_wzheros/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__